import React from 'react';
import { Bitcoin } from 'lucide-react';
import ModulePageLayout, { Section, FeatureGrid } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

const CHAINS = ['Ethereum', 'Polygon', 'Solana', 'BSC'];

export default function CryptoWalletPage() {
  const module = getModule('crypto-wallet')!;
  return (
    <ModulePageLayout module={module} Icon={Bitcoin}>
      <Section title="One Wallet, Every Major Chain">
        <p className="text-gray-700 leading-relaxed mb-4">
          Create or import wallets across the major chains, with deposit addresses, QR codes, and real-time
          balance tracking per currency, per wallet.
        </p>
        <div className="flex flex-wrap gap-2">
          {CHAINS.map((c) => (
            <span key={c} className="px-3 py-1.5 bg-amber-50 text-amber-800 rounded-full text-sm font-medium border border-amber-200">
              {c}
            </span>
          ))}
        </div>
      </Section>

      <Section title="More Than a Wallet">
        <FeatureGrid
          items={[
            { title: 'On-Chain Transaction History', body: 'Every deposit, withdrawal, and transfer recorded with hash, fee, confirmations, and timestamp.' },
            { title: 'NFT Portfolio', body: 'View and manage NFT holdings with contract address, token ID, collection, and acquisition date.' },
            { title: 'Staking Rewards', body: 'Track staking positions across platforms — reward amount, reward type, and claimed status.' },
            { title: 'Multiple Wallets', body: 'Set one wallet as primary while keeping others organized by currency and provider.' },
          ]}
        />
      </Section>
    </ModulePageLayout>
  );
}
